import type { Listing } from '@thevillages/schemas';

import { Component, input } from '@angular/core';

import { ListingDetailsAccordion } from '../accordion/accordion';

@Component({
  imports: [ListingDetailsAccordion],
  selector: 'app-listing-details-series-details',
  templateUrl: './series-details.html',
})
export class ListingDetailsSeriesDetails {
  public readonly listing = input.required<Listing>();
}
